import { SET_TYPE } from '../actionTypes';
import { configurationDocumentsActions } from '../reducer';

export default (values) => configurationDocumentsActions[SET_TYPE](values);
